import React from 'react';
import styles from './index.module.scss';

type Props = {
  data: { key: string; value: string }[];
};

const StatsSimple = (props: Props) => {
  return (
    <>
      <div className={styles.wrapper}>
        {props.data.map((item) => {
          return (
            <div className={styles.column}>
              <div className={styles.row}><span>{item.key}</span></div>
              <div className={styles.row}>{item.value ? item.value : '-'}</div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default StatsSimple;
